import axios from 'axios';
import fnc from '../../mymod/commFunction';
import {
  legacyApiUrl, isLegacyApiUrl, isTeacherApiUrl, isStudentApiUrl,
  TEACHER_SESSION_EXPIRED_EVENT, STUDENT_SESSION_EXPIRED_EVENT,
} from './apiUrl';

export * from 'axios';
const teacherAxios = axios.create();
teacherAxios.interceptors.request.use((config) => {
  const originalUrl = config.url || '';
  const resolvedUrl = config.baseURL && !/^(?:[a-z][a-z\d+.-]*:|\/\/)/i.test(originalUrl)
    ? `${config.baseURL.replace(/\/+$/, '')}/${originalUrl.replace(/^\/+/, '')}` : originalUrl;
  config.url = legacyApiUrl(resolvedUrl);
  // URLs are now resolved; do not let a caller's baseURL apply a second time.
  if (/^https?:\/\//i.test(config.url)) config.baseURL = undefined;
  config.headers = axios.AxiosHeaders.from(config.headers || {});
  const token = fnc.getCookie('appSessionToken');
  if (isLegacyApiUrl(config.url)) {
    const isStudent = isStudentApiUrl(config.url);
    if (!token) throw Object.assign(new Error(`${isStudent ? '학생' : '선생님'} 계정으로 로그인해 주세요.`), { code: 'LOGIN_REQUIRED' });
    config.headers.set('Authorization', `Bearer ${token}`);
    config.legacySessionToken = token;
    config.legacyApiNamespace = isStudent ? 'student-question-bank' : 'teacher-lms';
    if (isStudent) delete config.teacherSessionToken;
    else config.teacherSessionToken = token;
  } else {
    // Signed S3 uploads must never inherit any application's bearer header.
    config.headers.delete('Authorization');
    delete config.teacherSessionToken;
    delete config.legacySessionToken;
    delete config.legacyApiNamespace;
  }
  return config;
});
teacherAxios.interceptors.response.use(response => response, (error) => {
  const config = error.config || error.response?.config;
  const token = config?.legacySessionToken;
  const studentRequest = config?.legacyApiNamespace === 'student-question-bank' && isStudentApiUrl(config.url);
  const teacherRequest = config?.legacyApiNamespace === 'teacher-lms' && isTeacherApiUrl(config.url);
  if (error.response?.status === 401 && token && token === fnc.getCookie('appSessionToken') && (studentRequest || teacherRequest)) {
    const event = studentRequest ? STUDENT_SESSION_EXPIRED_EVENT : TEACHER_SESSION_EXPIRED_EVENT;
    window.dispatchEvent(new CustomEvent(event, { detail: { token } }));
  }
  return Promise.reject(error);
});
export default teacherAxios;
